import { AccessControl } from '@components/layout'
import { useToggleContacted } from '@services/users/mutations/useUserNotes'
import { useTranslation } from 'react-i18next'

import { Switch } from '@/components/ui/switch'

interface WasContactedToggleProps {
  userId: string
  wasContacted: boolean
}

export function WasContactedToggle({
  userId,
  wasContacted
}: WasContactedToggleProps) {
  const { t } = useTranslation('users')
  const { mutate: toggleContacted, isPending } = useToggleContacted()

  return (
    <AccessControl role="ADMIN">
      <div className="flex items-center gap-2.5">
        <span className="text-sm font-medium text-ink">
          {t('form.labels.wasContacted')}
        </span>
        <Switch
          checked={wasContacted}
          disabled={isPending}
          onCheckedChange={(checked) =>
            toggleContacted({ userId, wasContacted: checked })
          }
        />
      </div>
    </AccessControl>
  )
}
